import CategoryBar from '../components/util/CategoryBar';
import './StorePage.css';

const StoreHome = () => {
  const storeType = 'home';
  console.log('스토어 페이지 컴포넌트 storeType: ', storeType);
  const categories = [
    { id: 1, name: '스토어 홈', storeType: 'home' },
    { id: 2, name: '일반상품', storeType: 'normal' },
    { id: 3, name: '정기배송', storeType: 'delivery' },
    { id: 4, name: 'MY❤️', storeType: 'myInterest' },
  ];

  return (
    <div className="container">
      <CategoryBar categories={categories} currentCategory={'home'} />
      <img src="/store_main.png" style={{width: '100%'}} alt="store_home" />
    </div>
  );
};

export default StoreHome;
